import { Component, Input, OnInit } from '@angular/core';
import { RewardProvider } from "../../shared/providers/rewards.provider";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RewardCategoryModel, RewardSubCategoryModel } from '../../shared/models/rewards';

@Component({
  selector: 'app-reward-sub-categories',
  templateUrl: './reward-sub-categories.component.html',
  styleUrls: ['./reward-sub-categories.component.scss']
})
export class RewardSubCategoriesComponent implements OnInit {

  addOrEditRewardSubCategory: string;
  formGroup;
  deletePopupUiData;

  @Input() model = new RewardSubCategoryModel;


  constructor(
    public rewardProviders: RewardProvider,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public adminDataProvider: AdminDataProvider,

  ) { }

  rewardSubCategories:RewardSubCategoryModel[];
  rewardCategories:RewardCategoryModel[];
  rewardParentCategories:RewardCategoryModel[];

  ngOnInit() {
  }

  ngDoCheck() {
    this.rewardSubCategories = this.rewardProviders.rewardSubCategories;
    this.rewardCategories = this.rewardProviders.rewardCategory;
    this.rewardParentCategories = this.rewardProviders.rewardParentCategories;
    console.log( this.rewardCategories);
  }

  addRewardSubCategory(targetModal) {
    this.addOrEditRewardSubCategory = "add";
    this.formGroup = this.fb.group({
      sub_category_name: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      category_id: '',
      program_id: 1,
    });

    this.showRewardCategoryModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editRewardSubCategory(targetModal, rewardInfo) {
    this.addOrEditRewardSubCategory = "edit";
    this.formGroup = this.fb.group({
      id: rewardInfo.id,
      sub_category_name: new FormControl(rewardInfo.sub_category_name, [Validators.required]),
      description: new FormControl(rewardInfo.description, [Validators.required]),
      category_id: rewardInfo.category_id,
      program_id: 1,
    });

    this.showRewardCategoryModal(targetModal);
  }

  deleteRewardSubCategory(targetModal, rewardInfo){
    this.addOrEditRewardSubCategory = "delete";
    this.deletePopupUiData = rewardInfo.sub_category_name;
    this.formGroup = this.fb.group({
      id: rewardInfo.id,
      program_id: 1,
    });
    this.showRewardCategoryModal(targetModal);
  }



  showRewardCategoryModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitRewardSubCategory(formData) {
    this.submitted = true;
    console.log('model', this.model);
    if (this.formGroup.invalid) {
      return;
    }

    if (this.addOrEditRewardSubCategory == "add") {
      this.model.category_name = this.rewardCategories.find(i => i.id == formData.category_id).category_name;
      this.rewardProviders.addRewardSubCategoryList(formData);
      console.log('model', this.model);
      this.modalService.dismissAll();
    } else if (this.addOrEditRewardSubCategory == "edit") {
      this.model.category_name = this.rewardParentCategories.find(i => i.id == formData.category_id).category_name;
      this.rewardProviders.editRewardSubCategoryList(this.model);
      this.modalService.dismissAll();
    } else if (this.addOrEditRewardSubCategory == "delete") {
      this.rewardProviders.deleteRewardSubCategoryList(formData);
      this.modalService.dismissAll();
    }
    this.submitted = false;
  }

}

